import { ServerConfig } from "@/config/config";
import { MongoView, MongoViewTypes } from "@/models/mongo-view";
import { Axios } from "@/utils/axios";

class MongoViewServiceClass {
	public readonly URL = `${ServerConfig.host}/mongo-views`

	public async getByType(t:MongoViewTypes):Promise<MongoView[]>{
		let result = await Axios.get(`${this.URL}/by-type/${t}`);
		return ((result.data || []) as any[]).map(d=>new MongoView(d));
	}

	public async getByID(id:number):Promise<MongoView>{
		let result = await Axios.get(`${this.URL}/${id}`);
		return new MongoView(result.data);
	}

	public async createView(view:MongoView):Promise<MongoView>{
		let result = await Axios.post(`${this.URL}`, view.getJSON());
		return new MongoView(result.data);
	}

	public async updateView(view:MongoView):Promise<MongoView>{
		let result= await Axios.put(`${this.URL}/${view.ID}`, view.getJSON());
		return new MongoView(result.data);
	}

	public async deleteView(view:MongoView):Promise<void>{
		await Axios.delete(`${this.URL}/${view.ID}`);
	}
}


export const MongoViewService = new MongoViewServiceClass();